import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PaymentMethodTypeDesc from './paymentMethodTypeDesc.mdx';
import PaymentMethodHandlerDesc from './paymentMethodHandlerDesc.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called when a payment will be created.
Use as an opportunity to update UI accordingly - for example, to display a "loading" component.
The `}<inlineCode parentName="p">{`handler`}</inlineCode>{` must be used to then abort or continue with payment creation.
Primer will continue with payment creation if `}<inlineCode parentName="p">{`onBeforePaymentCreate`}</inlineCode>{` is not implemented.`}</p>
    <Group summary='Parameters' mdxType="Group">
    <Item title='checkoutPaymentMethodData' subtitle='PrimerCheckoutPaymentMethodData' mdxType="Item">
      <Group summary='Parameters' mdxType="Group">
              <Item title='paymentMethodType' subtitle='String' mdxType="Item">
                <PaymentMethodTypeDesc mdxType="PaymentMethodTypeDesc" />
              </Item>
              <Item title='paymentMethod' subtitle='String' mdxType="Item">
                The name of the payment method Primer will use for payment creation.
              </Item>
      </Group>
    </Item>
    <Item title='handler' subtitle='PrimerPaymentCreationHandler' mdxType="Item">
                <PaymentMethodHandlerDesc mdxType="PaymentMethodHandlerDesc" />
      <Group summary='Parameters' mdxType="Group">
              <Item title='abortPaymentCreation' subtitle='(errorMessage: string | null) => void' mdxType="Item">
                Choose to abort a payment.
              </Item>
              <Item title='continuePaymentCreation' subtitle='() => void' mdxType="Item">
                Choose to continue with payment creation
              </Item>
      </Group>
    </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      